import { render, staticRenderFns } from "./MessageAward.vue?vue&type=template&id=57fef656&scoped=true&lang=html&"
import script from "./MessageAward.vue?vue&type=script&lang=js&"
export * from "./MessageAward.vue?vue&type=script&lang=js&"
import style0 from "./MessageAward.vue?vue&type=style&index=0&id=57fef656&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fef656",
  null
  
)

export default component.exports